import React, { useEffect, useState } from "react";
import api from 'api';
import { Link, useNavigate } from 'react-router-dom';
//import {UserType} from '../../common/SelectCode'
import { API } from "common/config-api"; // jsconfig.json
import Pagination from "common/Pagination";

const UserListRow = ({u}) => {
  console.log(u.userType);
  return (
    <tr key={u.userIdx}>
      <th scope="row">{u.userCode}</th>
      <td>{u.userType}</td>
      <td>
          <Link to={`/user/${u.userCode}`}><b>{u.userNickname}</b></Link>
      </td>
      <td>{u.userGrade}</td>
      <td>￥{u.userPurchase.toLocaleString('ko-KR')}</td>
      <td>{u.userAttendance}</td>
      <td>{u.userDate}</td>
    </tr>
  );
}

const UserType = (callback, value) => {
  console.log("value", value.value);  
  return (
    <select className="form-select" onChange={callback} name="userType" aria-label="Default select example" defaultValue="dealer">
      <option value="">全部</option>
      <option value="dealer">ディーラー</option>
      <option value="wholesale">都賣</option>
      <option value="vip">VIP</option>
      <option value="etc">etc</option>
    </select>    
  );
}


const UserListDealer = () => {

  const [userList, setUserList] =  useState([]);

  const navigate = useNavigate();

  const apiUrl = `${API.BASE_URL}`;

  const [curPage, setCurPage] = useState(0); //현재 페이지 (0-based)
  const [totalPages, setTotalPages] = useState(0); //전체 페이지 수

  const [search, setSearch] = useState({
    page: 1,
    size: 20,
    keyword: '',
  });

  const getBoardList = async () => {
    try {
      const queryString = Object.entries(search).map((e) => e.join('=')).join('&');

      const response = await api.get(apiUrl + '/user/dealer?' + queryString);
      const resp = response;

      console.log(apiUrl + '/user/dealer?' + queryString);

      // Page<> 응답 처리
      const userListData = resp?.content || [];
      const pageInfo = resp?.page;

      setUserList(userListData);
      setCurPage(pageInfo?.number || 0);
      setTotalPages(pageInfo?.totalPages || 1);

      console.log("Dealer List Data:", userListData);
      console.log("Current Page:", pageInfo?.number, "Total Pages:", pageInfo?.totalPages);
    } catch (error) {
      console.error('딜러 목록 조회 실패:', error);
      alert('딜러 목록 조회 중 오류가 발생했습니다.');
    }
  };


  /*const userRegist = () => {
    navigate('/user/regist');
  };*/

  const onPageChange = (page) => {
    // page는 1-based 페이지 번호
    setSearch({...search, page: page});
  };

  const onChange = (event) => {
    const { value, name } = event.target;
    console.log(name, value);
    setSearch({...search, [name]: value, page: 1});
  };

  const onSearch = () => {
    console.log("testOnSearch");
    setSearch({...search, page: 1});
  };

  useEffect(() => {
    getBoardList(); // 1) 게시글 목록 조회 함수 호출
  }, [search]);


 


    return (


        <div className="row">

          <div className="card">
            <div className="card-body">
              <h5 className="card-title">member list</h5>


                <div className="row mb-3">
                  <div className="col-sm-4">
                    <input type="text" name="keyword" onChange={onChange} className="form-control" placeholder="search keywords" defaultValue={search.keyword} />
                  </div>
                  <div className="col-sm-4">
                    {/*selectComponent*/}
                    <select className="form-select" onChange={onChange} name="userType" aria-label="Default select example" value={search.userType}>
                      <option value="">全部</option>
                      <option value="user">ユーザー</option>
                      <option value="dealer">ディーラー</option>
                      <option value="wholesale">都賣</option>
                      <option value="vip">VIP</option>
                      <option value="etc">etc</option>
                    </select>                        
                  </div>
                  <div className="col-sm-2">
                    <button type="button" onClick={onSearch} className="btn btn-primary">찾기</button>
                  </div>
                </div>


              <table className="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">코드</th>
                    <th scope="col">구분</th>
                    <th scope="col">닉네임</th>
                    <th scope="col">멤버등급</th>
                    <th scope="col">누적구매</th>
                    <th scope="col">출석일수</th>
                    <th scope="col">등록일</th>
                  </tr>
                </thead>
                <tbody>

                {userList.map((users, idx) => ( <UserListRow key={idx} u={users} /> ))}

                </tbody>
              </table>

              <Pagination
                currentPage={curPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
              />

            </div>
          </div>
        </div>

    );

}

export default UserListDealer;